import { NYTBook } from "./fetchBooks";

export async function selectRandomBooks(
  books: NYTBook[],
  count: number
): Promise<NYTBook[]> {
  console.log(books);
  const shuffledBooks = shuffleArray([...books]);
  return shuffledBooks.slice(0, count);
}

function shuffleArray(array: NYTBook[]): NYTBook[] {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}
